module.exports = __webpack_public_path__ + "static/integrate-automate-38c2a6427a740031da44053c48b0a8d9.png";